// extracted by mini-css-extract-plugin
module.exports = {"fontsize":"TicketingV1Form_fontsize__1mPjG","bold":"TicketingV1Form_bold__A43RO","ticketGroup":"TicketingV1Form_ticketGroup__2j1xX","hr":"TicketingV1Form_hr__nre2u"};